import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useIsMobile } from '../../hooks/useMediaQuery';
import Button from '../Button';
import HamburgerMenu from './HamburgerMenu';
import ThemeToggle from '../theme/ThemeToggle';
import '@fortawesome/fontawesome-free/css/all.min.css';

const AuthHeader: React.FC = () => {
  const isMobile = useIsMobile();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header sticky-top" style={{ backgroundColor: 'var(--sb-bg)' }}>
      <nav className="navbar navbar-expand-lg">
        <div className="container">
          <Link className="navbar-brand fw-bold text-primary" to="/">
            <i className="fas fa-laptop me-2"></i>
            <span className="d-none d-sm-inline">SadeceBilgisayar.com</span>
            <span className="d-inline d-sm-none">SadeceBilgisayar</span>
          </Link>

          {!isMobile && (
            <div className="nav-right ms-auto d-flex align-items-center">
              <ThemeToggle className="me-3 text-primary fs-5" />
              <Link to="/" className="btn btn-primary">
                Anasayfa
              </Link>
            </div>
          )}

          {isMobile && (
            <Button
              type="button"
              className="btn btn-link header-toolbar-icon p-2 ms-auto"
              onClick={() => setMenuOpen(true)}
              aria-label="Menüyü aç"
            >
              <i className="fas fa-bars fa-lg" />
            </Button>
          )}
        </div>
      </nav>

      {isMobile && (
        <HamburgerMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)}>
          <Link to="/" className="d-flex align-items-center py-3 text-dark text-decoration-none border-bottom">
            <i className="fas fa-home me-2 text-primary" />
            Anasayfa
          </Link>
          <div className="d-flex align-items-center py-3 border-bottom">
            <ThemeToggle className="text-primary fs-5" showLabel />
          </div>
        </HamburgerMenu>
      )}
    </header>
  );
};

export default AuthHeader;
